<div class="flex-left-column light-control-host">
  <div class="flex-center-row">
    <h3 class="panel-title">Conclude recovery for "{{ !!application ? application.name : '' }}"</h3>
  </div>
  <div>
    <div class="margin-top error">
      Note: Concluding recovery for an application will dispose of resources in the recovery region, returning the
      application to an idle state. Do not perform this action until you no longer need these resources.
    </div>
  </div>
  <div class="margin-top">Select applications to turn down in {{ !!application ? application.targetRegion : '' }}</div>
  <!-- Select All Checkbox -->
  <div class="select-all-container resource-type flex-center-row margin-top" *ngIf="applications.length > 0">
    <input
      type="checkbox"
      class="arpio-checkbox"
      [checked]="areAllApplicationsSelected()"
      (change)="toggleSelectAllApplications($event.target.checked)"
      [disabled]="applications.length === 0"
    />
    <div class="select-all-label" (click)="toggleSelectAllApplications(!areAllApplicationsSelected())">
      {{ areAllApplicationsSelected() ? 'Deselect All' : 'Select All' }}
    </div>
  </div>
  <div class="flex-center-row full-width margin-top">
    <div id="applicationSelectionList" class="light-content-panel dialog-selection-list spacer">
      <div class="flex-center-row" *ngFor="let application of applications; trackBy: applicationTrackBy">
        <input
          id="app-id"
          class="arpio-checkbox"
          type="checkbox"
          (input)="toggleApplicationSelection(application.applicationObj.applicationId)"
          [checked]="applicationIsChecked(application.applicationObj)"
        />
        <div class="application-name margin-left">{{ application.applicationObj.name }}</div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="currentlySyncing">
    <div class="error margin-top flex-center-row full-width">
      <p class="full-width">
        Arpio is launching a recovery, once it is done, you will be able to conclude your recovery.
      </p>
    </div>
    <div class="error flex-center-row full-width">
      <div class="spacer"></div>
      <h1><i class="fa-solid fa-spinner fa-spin"></i></h1>
      <div class="spacer"></div>
    </div>
  </ng-container>
  <div class="flex-center-row margin-top full-width">
    <div class="spacer"></div>
    <button class="arpio-secondary-button" (click)="onCancelClick()">CANCEL</button>
    <button
      busy-button
      [busy]="launching"
      id="conclude-button"
      class="arpio-button margin-left"
      (click)="onConcludeClick()"
      [disabled]="launching"
    >
      CONCLUDE RECOVERY
    </button>
    <div class="spacer"></div>
  </div>
</div>
